import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.scrollY = 0;
  }

  // action="click->hamburger-menu#toggle"
  toggle({ currentTarget }) {
    currentTarget.classList.toggle('is-open');

    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle('is-open');
    }

    if (currentTarget.classList.contains('is-open')) {
      currentTarget.classList.remove('is-close');
      this.#fixed();
    } else {
      currentTarget.classList.add('is-close');
      this.#release();
    }
  }

  #fixed() {
    this.scrollY = window.scrollY;
    Object.assign(this.element.style, {
      position: 'fixed',
      width: '100%',
      top: `${-this.scrollY}px`,
    });
  }

  #release() {
    Object.assign(this.element.style, {
      position: 'relative',
      width: '',
      top: '',
    });
    window.scrollTo({ top: this.scrollY });
  }
}
